




import { EmailService } from "@/services/api/email.service";
import { DialogsModule } from "@/store/dialogs.module";
import { Component, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import { AuthService } from "@/services/auth.service";

@Component
export default class FVerify extends Vue {
  async created() {
    const { query } = this.$route;
    if (!query.secret) {
      return this.$router.replace("/profile");
    }

    if (query.isUser) {
      const { result, message } = await EmailService.verifyUserEmail(
        query.secret as string,
      );
      await AuthModule.getUser();

      this.$router.push(AuthModule.user ? "/profile" : "/auth");

      DialogsModule.setEmailConfirmationDialog({
        show: true,
        isSent: true,
        isUser: true,
        text: (result
          ? this.$t("profile.organization.email.card-text-confirm")
          : message) as string,
      });

      return;
    }

    const { result, message } = await EmailService.verify(
      query.secret as string,
    );
    await AuthModule.getUser();
    if (result.isOrganizationsMatch === false) AuthService.logout();
    else await this.$router.push(AuthModule.user ? "/profile" : "/auth");
    DialogsModule.setEmailConfirmationDialog({
      show: true,
      isSent: true,
      text: (result
        ? this.$t("profile.organization.email.card-text-confirm")
        : message) as string,
    });
  }
}
